import React from 'react';

function OpportunitiesStatus({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                d="M8.5 14.223h1V13.11h3v1.112h1V13.11h2v2.778c0 .616-.445 1.111-1 1.111h-7c-.555 0-1-.495-1-1.111l.005-2.778H8.5v1.112ZM12 7c.555 0 1 .495 1 1.111v.556h2c.55 0 1 .5 1 1.11v1.667c0 .611-.45 1.112-1 1.112h-1.5v-1.112h-1v1.112h-3v-1.112h-1v1.112H7c-.555 0-1-.495-1-1.112V9.777c0-.61.45-1.11 1-1.11h2v-.556C9 7.495 9.445 7 10 7h2Zm-2 1.111v.556h2v-.556h-2Z"
            />
            <path
                fill={color}
                fillRule="evenodd"
                d="m23 8.358-1.846.445C19.695 2.99 14.081-.288 8.61 1.478 3.14 3.245-.11 9.384 1.35 15.198c1.264 5.035 5.33 7.577 9.32 7.841 5.312.509 9.941-2.75 10.65-7.736l-2.644-.557c-.375 2.978-3.22 5.261-6.545 5.652-3.575.235-7.378-2.304-8.306-6-1.093-4.353 1.348-8.966 5.446-10.29 4.097-1.322 8.315 1.14 9.408 5.494l-1.88.956 4.51 2.75L23 8.358Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

export default OpportunitiesStatus;
